import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/permission_controls_analytics_event.py
export const PERMISSION_CONTROLS_ANALYTICS_ACTIONS = {
  ENABLED_FOLDER_PERMISSIONS: {
    module: ANALYTICS_MODULE.PERMISSION_CONTROLS,
    action: 'enabled_folder_permissions',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DISABLED_FOLDER_PERMISSIONS: {
    module: ANALYTICS_MODULE.PERMISSION_CONTROLS,
    action: 'disabled_folder_permissions',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DISABLE_FOLDER_PERMISSIONS_FAILED_FROM_LACK_OF_FOLDER_ACCESS: {
    module: ANALYTICS_MODULE.PERMISSION_CONTROLS,
    action: 'disable_folder_permissions_failed_from_lack_of_folder_access',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
